import '@vkontakte/vkui/dist/vkui.css';
import './App.css';
import React,{useEffect, useState, Suspense} from 'react';
import bridge from "@vkontakte/vk-bridge";
import {
    AdaptivityProvider,
    AppRoot,
    ConfigProvider,
    SplitLayout,
    View, Alert, ScreenSpinner
} from "@vkontakte/vkui";
import ProfilePanel from "./ProfilePanel/ProfilePanel";
import {useDispatch, useSelector} from "react-redux";
import {getUserPrefs, loginUser, registerUser, setEmail, toggleNeedRegister, updateUserPrefs} from "./Redux/authReducer";
import {
    initialisedSuccess,
    setActivePanel,
    setAppInfo,
    setClient,
    setOnlineStatus, setScheme, toggleShowGuide, updateMiniSettings,
    wsMessageHandler
} from "./Redux/appReducer";
import InitPanel from "./InitPanel/InitPanel";
import Modal from "./Modal/Modal";
import QuestionPanel from "./QuestionPanel/QuestionPanel";
import AskPanel from "./AskPanel/AskPanel";
import UserStatsPanel from "./UserStatsPanel/UserStatsPanel";

import useWebSocket,{ ReadyState } from "react-use-websocket";
import {checkDev} from "./utils/helpers";
import NotifyPanel from "./NotifyPanel/NotifyPanel";
import ChatsPanel from "./ChatsPanel/ChatsPanel";
import ChatPanel from "./ChatPanel/ChatPanel";
import {loadRandomQuest} from "./Redux/questionReducer";
import SettingsPanel from "./SettingsPanel/SettingsPanel";
import BannedDeletedPanel from "./BannedDeletedPanel/BannedDeletedPanel";
import {getRouterHash, historyPush, loadHash, toggleDoNotAdd} from "./Redux/routerReducer";
import RewardsPanel from "./RewardsPanel/RewardsPanel";
import LogsPanel from "./LogsPanel/LogsPanel";
import LeadersPanel from "./LeadersPanel/LeadersPanel";
import RatePanel from "./RatePanel/RatePanel";
import GiftPanel from "./GiftPanel/GiftPanel";
import StaticPanel from "./StaticPanel/StaticPanel";
import ErrorPanel from './ErrorPanel/ErrorPanel';
const Guide = React.lazy(() => import("./Guide/Guide"));
//import Guide from './Guide/Guide';



function App() {

    /*
    Для роутера
    const hash = window.location.hash.split('/')
    console.log(hash[1],hash[2])
    https://vk.com/app7301497#/q/id
    https://vk.com/app7301497#/a/id
    https://vk.com/app7301497#/@/username
    https://vk.com/app7301497#/pm/username
     */

    const dispatch = useDispatch();
    const app = useSelector(state => state.app);
    const auth = useSelector(state => state.auth);
    const [popout, setPopout] = useState(null);

    const doNotAdd = useSelector(state => state.router.doNotAdd);
    const hash = useSelector(state => state.router.hash);



    const {
        sendMessage,
        lastMessage,
        readyState,
    } = useWebSocket(checkDev(`/ws/init${app.cookiesSupport===false?`?token=${localStorage.getItem('access_token')}`:''}`,true), {
        shouldReconnect: async (closeEvent) =>{
            if(closeEvent.code === 4001){
                //let status = await dispatch(refreshTokens())
                return false // status === 0;
            }
            else {
                return true
            }
        },
        retryOnError: true,
        }, app.onlineReady
    );


    const connectionStatus = {
        [ReadyState.CONNECTING]: 'Connecting',
        [ReadyState.OPEN]: 'Open',
        [ReadyState.CLOSING]: 'Closing',
        [ReadyState.CLOSED]: 'Closed',
        [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
    }[readyState];


    const allowNotificationMessage = () => {
        setPopout(
            <Alert
                actions={[{
                    title: 'Отменить',
                    autoclose: true,
                    mode: 'cancel'
                }, {
                    title: 'Разрешить',
                    autoclose: true,
                    action: () => bridge.send("VKWebAppAllowNotifications").catch((e)=>{console.log(e)})
                }]}
                actionsLayout="horizontal"
                onClose={()=>{setPopout(null)}}
                header={<div style={{textAlign:"center"}}>Уведомления от приложения</div>}
                text={<>
                    <div style={{textAlign:"center"}}>Разрешите приложению отправлять Вам уведомления в "колокольчик",</div>
                    <div style={{textAlign:"center"}}>и будете всегда в курсе, что произошло за время Вашего отсутсвия.</div>
                    <div style={{textAlign:"center",marginTop:10}}>🙂</div>
                </>}
            />
        )
    }
    const getUserEmail = () => {
        setPopout(
            <Alert
                actions={[{
                    title: 'Отменить',
                    autoclose: true,
                    mode: 'cancel'
                }, {
                    title: 'Добавить',
                    autoclose: true,
                    action: () => bridge.send("VKWebAppGetEmail", {})
                        .then((response)=>{
                            dispatch(setEmail({url:window.location.href,email:response.email,sign:response.sign}))
                                .then((response)=>{
                                    if(response===2) localStorage.setItem('new_email_error','1')
                                })
                        })
                        .catch((e)=>{console.log(e)})
                }]}
                actionsLayout="horizontal"
                onClose={()=>{setPopout(null)}}
                header={<div style={{textAlign:"center"}}>Добавьте email</div>}
                text={<>
                    <div style={{textAlign:"center"}}>Добавьте email, и сможете получать уведомления о новых ответах, комментариях и личных собщениях.</div>
                    <div style={{textAlign:"center"}}>Также Вы сможете подписаться на новостную рассылку приложения.</div>
                    <div style={{textAlign:"center",marginTop:10}}>🙂</div>
                </>}
            />
        )
    }


    //запрос разрешения на отправку уведомлений
    useEffect(()=>{
        if(app.initialised&&!app.info.notifications) setTimeout(allowNotificationMessage,60000)
    },[app.initialised]);
    
    //запрос почты, статус сохраняется на сервере
    useEffect(()=>{
        if(app.initialised&&app.info.notifications&&!auth.user.email&&!auth.new_email&&!auth.new_email_error.id&&auth.prefs.email_requested===false) {
            setTimeout(()=>{getUserEmail();dispatch(updateUserPrefs(window.location.href,'email',1))},120000)}
    },[auth.prefs.email_requested]);


    useEffect(()=>{
        if(readyState === ReadyState.OPEN) sendMessage('whoAmI')
        dispatch(setOnlineStatus(readyState === ReadyState.OPEN))
    },[readyState]);

    useEffect(()=>{
        if(lastMessage) dispatch(wsMessageHandler(JSON.parse(lastMessage.data)))
    },[lastMessage]);

    //инициализация приложение
    useEffect(()=>{
        bridge.send("VKWebAppInit", {}).then((result)=>{if(result) {
            dispatch(setAppInfo(window.location.href))
            dispatch(getRouterHash(window.location.hash))
        }})
        bridge.send("VKWebAppGetClientVersion");
        bridge.subscribe((e) => {
            if(e.detail.type==='VKWebAppUpdateConfig') {
                document.body.setAttribute('scheme', e.detail.data.scheme)
                dispatch(setScheme(e.detail.data.scheme))
            }
            else if (e.detail.type === 'VKWebAppAllowNotificationsResult'||e.detail.type === 'VKWebAppDenyNotificationsResult') {
                dispatch(updateMiniSettings(window.location.href,{notifications:e.detail.type === 'VKWebAppAllowNotificationsResult'}))
            }
            else if (e.detail.type === 'VKWebAppGetClientVersionResult'){
                dispatch(setClient(e.detail.data))
            }
        })
        window.addEventListener('focus',()=>{
            sendMessage('whoAmI')
        })
    },[]);

    //после получения адреса, запрашиваем токены с сервера, если приложение у пользователя установлено.
    useEffect(()=>{
        if(app.info.qs&&app.info.installed) {
            dispatch(loginUser(app.info.qs))
        }
    },[app.info.qs,app.info.installed]);


    // если от сервеа приходит статус 2 - регистрируем пользователя (заглушка на случай, если приложение установлено, но пользователя такого нет)
    useEffect(async ()=>{
        const userInfo = await bridge.send("VKWebAppGetUserInfo");
        if(auth.need_register&&!app.info.installed) {
            await bridge.send('VKWebAppGetAuthToken', {app_id: 7301497, scope: ''})
                .then(()=>{dispatch(registerUser(app.info.qs,userInfo))})
                .catch(()=>{dispatch(toggleNeedRegister(false))})
        }
        else if (auth.need_register) dispatch(registerUser(app.info.qs,userInfo))
    },[auth.need_register]);




    //Ставим статус "инициализировано", если приложение онлайн, пользователь авторизовался и инициализации не было до этого
    useEffect(() => {
        if(!app.initialised&&auth.is_authenticated &&app.online
            ) {
            dispatch(initialisedSuccess());
        }

    }, [auth.is_authenticated, app.online
    ])

    //Загружаем стартовую страницу
    useEffect(()=>{
        if(app.initialised){
            if([101,103].includes(auth.userStatus)) dispatch(setActivePanel('bannedDeleted'))
            else if(hash.panel) dispatch(loadHash(hash))
            else {
                dispatch(setActivePanel('question'));
                dispatch(loadRandomQuest())
            }
            dispatch(getUserPrefs(window.location.href))
        }
    },[app.initialised,auth.userStatus]);

    //router
    useEffect(()=>{

        if(app.activePanel&&!doNotAdd && !["init","question","stats","chat","bannedDeleted"].includes(app.activePanel)){
            dispatch(historyPush({
                panel: app.activePanel,
                type:null,
                id: null
            }))
        }
        dispatch(toggleDoNotAdd(false))
    },[app.activePanel]);

    const getTokenError = () =>{
        try{
            return localStorage.getItem('token_error');
           }
        catch(e) {return null}
    }
    
    //отслеживаем ошибку обновления токена
    useEffect(()=>{
        if(getTokenError()){
            localStorage.removeItem('token_error')
            console.error('Token Refresh Error')
            dispatch(setActivePanel('error'))
        }
    },[getTokenError()]);

    //Авто подсказки. Статус сохраняется на стороне сервера

    useEffect(()=>{
        if(auth.prefs.guide_viewed===false&&app.activePanel==='question'){
            setTimeout(() => {
                dispatch(toggleShowGuide(true));
                dispatch(updateUserPrefs(window.location.href,'guide',1))
            }, 3000);
        }
    },[auth.prefs.guide_viewed]);

  return (
      <ConfigProvider>
        <AdaptivityProvider>
          <AppRoot
              noLegacyClasses
          >
              <SplitLayout >
                  <View activePanel={app.activePanel} popout={popout} modal={<Modal id={'modal'} activeModal={app.activeModal} setPopout={setPopout}/>}>
                      <ProfilePanel
                          id={"profile"} setPopout={setPopout}/>
                      <InitPanel
                          id={"init"}/>
                      <QuestionPanel id={"question"} setPopout={setPopout}/>
                      <UserStatsPanel
                          id={"stats"} setPopout={setPopout}
                      />
                      <AskPanel
                          id={"ask"}
                      />
                      <NotifyPanel
                          id={"notify"}
                      />
                      <ChatsPanel
                          id={"chats"}
                      />
                      <ChatPanel
                          id={"chat"}
                      />
                      <SettingsPanel
                          id={"settings"}
                          setPopout={setPopout}
                      />
                      <BannedDeletedPanel
                          id={"bannedDeleted"}
                      />
                      <RewardsPanel
                          id={"rewards"}
                      />
                      <LogsPanel
                          id={"logs"}
                      />
                      <LeadersPanel
                          id={"leaders"}
                      />
                      <RatePanel
                          id={"rate"}
                          setPopout={setPopout}
                      />
                      <GiftPanel
                          id={"gifts"}
                          setPopout={setPopout}
                      />
                      <StaticPanel
                          id={"static"}
                      />
                      <ErrorPanel
                          id={"error"}
                      />
                  </View>
              </SplitLayout>
              {app.showGuide&&<Suspense 
              fallback={<ScreenSpinner/>}><Guide/></Suspense>}
          </AppRoot>
        </AdaptivityProvider>
      </ConfigProvider>
  );
}

export default App;
